export * from './link-type-one.module';